module.exports = __webpack_public_path__ + "assets/img/filesUpload.4779e124.png";